import React from 'react';
import { Link } from 'react-router-dom';
import LogOutButton from '../LogOutButton/LogOutButton';
import './Nav.css';
import {useSelector} from 'react-redux';
import Navbar from 'react-bootstrap/Navbar';

function Nav() {
  const user = useSelector((store) => store.user);
  let loginLinkData = {
    path: '/login',
    text: 'Login',
  };
  if (user.id != null) {
    loginLinkData.path = '/user';
    loginLinkData.text = 'Home';
  }
  return (
    <Navbar sticky="top" expand="lg" bg="primary" className="d-flex justify-content-between flex-md-nowrap p-0 shadow">
      <Link className="navLink" to="/home">
      <div className="d-flex justify-content-center align-middle">
      <a className="d-flex justify-content-center navbar-brand">
        <img src='images/fmrrv-header.png' height="98px" width="156px" alt="FMRRV"/>  
      </a>
      <div className="d-flex-inline align-middle mt-4 ml-3">
      <h2 className="nav-title">FURNITURE MISSION</h2>
      <h6 className="nav-subheader">OF THE RED RIVER VALLEY</h6>
      </div>
      </div>
      </Link>
      <div>
        {user.id != undefined ?
          <>
          </>
          :
            <Link className="navLinks" to="/referraltab">
              Referral Form 
            </Link>
        }
        <Link className="navLinks" to={loginLinkData.path}>
          {loginLinkData.text}
        </Link>
        {user.id && (
          <>
            {/* <Link className="navLink" to="/requests">
              Requests
            </Link> */}
            <Link className="navLinks" to="/warehouse">
              Warehouse
            </Link>
            <Link className="navLinks" to="/statistics">
              Statistics
            </Link>
            <Link className="navLinks" to="/partner">
              Referral Partner
            </Link>
            <Link className="navLinks" to="/settings">
              Settings
            </Link>
            <LogOutButton className="navLinks" />
             </>
        )} 
        <Link className="navLinks" to="/about">
          About
        </Link>
      </div>
    </Navbar>
  );
}

export default Nav;
